import api from './api';

export const speedWithUiUnit = (speed) => {
    const convertedSpeed = api.trackerSpeedFactor ? api.trackerSpeedFactor * speed : speed;
    return `${convertedSpeed.toFixed(1)} ${api.ui_units_speed || ''}`;
}

export const distanceWithUiUnit = (distance) => {
    const convertedDistance = api.trackerDistanceFactor ? api.trackerDistanceFactor * distance : distance;
    return `${convertedDistance.toFixed(2)} ${api.ui_units_distance || ''}`;
}